import { LANGUAGES } from '../consts';
import { CancellationAlert, FoodItem, listRestaurantType, RestaurantWithFoodType } from '../interfaces/types';

export type PaymentNoticeAlertItem = {
  restaurantName?: string;
  title: string;
  body: string;
};

const trimText = (value?: string) => value?.trim() || '';

const normalizeCancellationAlert = (alert: CancellationAlert | undefined, language?: string): Omit<PaymentNoticeAlertItem, 'restaurantName'> | null => {
  if (!alert?.enabled) return null;

  const isJapanese = language === LANGUAGES.JAPAN;
  const title = trimText(isJapanese ? alert.title_ja : alert.title_en);
  const body = trimText(isJapanese ? alert.body_ja : alert.body_en);

  if (!title || !body) return null;
  return { title, body };
};

type OrderRestaurantSource = {
  foods?: FoodItem[];
  promotion_foods?: FoodItem[];
  restaurant_id?: string;
  restaurant_ids?: string[];
  promotion_restaurant_id?: string;
};

export const getOrderRestaurantIds = (order: OrderRestaurantSource) => {
  const ids: string[] = [];
  const addId = (id?: string) => {
    if (id && !ids.includes(id)) ids.push(id);
  };

  (order.foods ?? []).forEach((food: any) => addId(food.restaurantId ?? food.restaurant_id));
  (order.promotion_foods ?? []).forEach((food: any) => addId(food.restaurantId ?? food.restaurant_id ?? order.promotion_restaurant_id));
  (order.restaurant_ids ?? []).forEach(addId);
  addId(order.restaurant_id);

  return ids;
};

export const getPaymentNoticeAlerts = ({
  order,
  restaurants,
  language,
}: {
  order: OrderRestaurantSource;
  restaurants: Array<listRestaurantType | RestaurantWithFoodType | undefined>;
  language?: string;
}): PaymentNoticeAlertItem[] => {
  const restaurantById = new Map<string, listRestaurantType | RestaurantWithFoodType>();
  restaurants.forEach((restaurant) => {
    if (restaurant?.id && !restaurantById.has(restaurant.id)) {
      restaurantById.set(restaurant.id, restaurant);
    }
  });

  return getOrderRestaurantIds(order).reduce<PaymentNoticeAlertItem[]>((alerts, restaurantId) => {
    const restaurant = restaurantById.get(restaurantId);
    const alert = normalizeCancellationAlert(restaurant?.cancellation_alert, language);
    if (!alert) return alerts;

    alerts.push({
      ...alert,
      restaurantName: restaurant?.name,
    });
    return alerts;
  }, []);
};
